<div class="main-container">
  <img src="assets/GlobeIQ_withTagline.svg" />
  <div class="message">{{ message }}</div>
  <div class="styled-button" routerLink="[/login]">Login</div>
</div>
